import * as moment from 'moment';
var WorkSlip = /** @class */ (function () {
    function WorkSlip() {
    }
    Object.defineProperty(WorkSlip.prototype, "CustomAddress", {
        /**
         * Gets the full address of the customer.
         *
         * @type {string}
         */
        get: function () {
            var street = this['CustomerAddress'] || '';
            var postalCode = this['CustomerPostalCode'] || '';
            var place = this['CustomerPlace'] || '';
            var country = this['CustomerCountry'] || '';
            var address = street + '\n\n' + postalCode + ' ' + place;
            if (country) {
                address += '\n\n' + country;
            }
            return address;
        },
        /**
         * Sets nothing, only needed for angular binding.
         */
        set: function (value) {
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkSlip.prototype, "TotalSpend", {
        /**
         * Gets the sum of the efforts on this assignment.
         * @type {string}
         */
        get: function () {
            return this.getTotalOf('Effort');
        },
        /**
         * Sets nothing, only needed for angular binding.
         */
        set: function (value) {
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkSlip.prototype, "TotalTravelTime", {
        /**
         * Gets the sum of the travel time booked on this assignment.
         * @type {string}
         */
        get: function () {
            return this.getTotalOf('TravelTime');
        },
        /**
         * Sets nothing, only needed for angular binding.
         */
        set: function (value) {
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the sum of the time of the input
     * @param {string }inputTime
     */
    WorkSlip.prototype.getTotalOf = function (inputTime) {
        var spendTimeItems = this['SpendTimeItems'];
        var PT05 = 'PT05';
        if (!spendTimeItems || spendTimeItems.length === 0) {
            return PT05;
        }
        var result = moment.duration(PT05);
        spendTimeItems.forEach(function (item) {
            result.add(item[inputTime]);
        });
        return result.toISOString();
    };
    return WorkSlip;
}());
export { WorkSlip };
